function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_vm._v("list of addons:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("multiboxer\n"),_c('ul',[_c('li',[_vm._v("accounting")]),_vm._v(" "),_c('li',[_vm._v("data")]),_vm._v(" "),_c('li',[_vm._v("utils")])])])])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {},
    
      body: "# list of addons:\r\n- multiboxer\r\n  - accounting\r\n  - data\r\n  - utils",
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }